import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TransactionPayload {
  hash: string;
  summary: string;
  from: string;
  addedTime: number;
  chainId: number;
  completeMessage?: string;
  errorMessage?: string;
}

export interface CompletedTransaction extends TransactionPayload {
  status?: number;
  confirmedTime?: number;
}

export type MappedTransactions = { [hash: string]: CompletedTransaction };

interface TransactionsState {
  data: MappedTransactions;
  transactions: string[];
  pending: string[];
}

const initialState: TransactionsState = {
  data: {},
  transactions: [],
  pending: [],
};

export const transactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    addTransaction: (state, action: PayloadAction<TransactionPayload>): void => {
      state.data[action.payload.hash] = action.payload;
      state.transactions = Array.from(new Set([...state.transactions, action.payload.hash]));
      state.pending = Array.from(new Set([...state.pending, action.payload.hash]));
    },
    setCompletedTransaction: (state, action: PayloadAction<CompletedTransaction>): void => {
      state.data[action.payload.hash].confirmedTime = action.payload.confirmedTime;
      state.data[action.payload.hash].status = action.payload.status;
      state.pending = state.pending.filter((hash) => hash !== action.payload.hash);
    },
    clearTransactions: (state): void => {
      state.data = {};
      state.transactions = [];
      state.pending = [];
    },
  },
});
